
export const spotlightDistanceFromConnector = 20;
export const spotlightDistanceFromSpotlight = 20;
export const doubleSpotlightDistanceFromConnector = 40;
export const maxDistanceFromWallToSetSpotDirectionDown = 100;
